import { IRectangleCoordinatableObject } from "../../../../../../domain/editableFormat/objects";
import { IRectangleCoordinatableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { ObjectTranslator } from "./ObjectTranslator";

export class RectangleCoordinatableObjectTranslator<TObject extends IRectangleCoordinatableObject, TBean extends IRectangleCoordinatableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new ObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.location = {
      x: this.integer.from(bean["@x"]),
      y: this.integer.from(bean["@y"]),
    };
    source.size = {
      width: this.integer.from(bean["@width"]),
      height: this.integer.from(bean["@height"]),
    };
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@x"] = this.integer.to(object.location.x);
    source["@y"] = this.integer.to(object.location.y);
    source["@width"] = this.integer.to(object.size.width);
    source["@height"] = this.integer.to(object.size.height);
  }
}
